var React = require('react');

function Protect (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0Z","fill":"#676D73"}));
}

Protect.defaultProps = {"width":"18","height":"22","viewBox":"0 0 18 22","fill":"none"};

module.exports = Protect;

Protect.default = Protect;
